import { render, staticRenderFns } from "./right.vue?vue&type=template&id=54ed281a&scoped=true"
import script from "./right.vue?vue&type=script&lang=js"
export * from "./right.vue?vue&type=script&lang=js"
import style0 from "./right.vue?vue&type=style&index=0&id=54ed281a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ed281a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54ed281a')) {
      api.createRecord('54ed281a', component.options)
    } else {
      api.reload('54ed281a', component.options)
    }
    module.hot.accept("./right.vue?vue&type=template&id=54ed281a&scoped=true", function () {
      api.rerender('54ed281a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/cockpit/components/warning/right.vue"
export default component.exports